import React from 'react'
import Sidebar from './comps/Sidebar';
import Topbar from './comps/Topbar';
import { TaskFilterBar } from './comps/TaskFilterBar';
import { useCommon } from 'hooks';
import { ETaskActions } from 'types';

export default function MasterLayout({ children }: any) {
    const actionsTaskState = useCommon(state => state.actionsTaskState)
    return (
        <div className="flex h-screen overflow-hidden">
            {/* Sidebar */}
            <Sidebar />
            {/* Main Content */}
            <div className="flex-1 flex flex-col bg-gray-50">
                <div className='flex flex-col relative'>
                    <Topbar />
                    {/* {!!actionsTaskState?.method?.[ETaskActions.SHOW_FILTER] && <div className='flex flex-col absolute bg-white w-full top-[57px] border-b border-gray-200 animate-modal-up'>
                        <TaskFilterBar />
                    </div>} */}
                </div>
                <main className="flex-1 overflow-y-auto p-6">{children}</main>
            </div>
        </div>
    );
}
